import {NgModule} from '@angular/core';

import {SharedModule} from '../shared/shared.module';

import {
  IamTableComponent,
  IamPeriodComponent,
  SignProgressComponent,
  SigningComponent,
  CountyGeoComponent,
  TaxAuthorityComponent,
  AttachmentViewerComponent
} from './components/entity';
import {ProgressSpinnerModule} from 'primeng-lts/progressspinner';

@NgModule({
  declarations: [
    IamTableComponent,
    IamPeriodComponent,
    SignProgressComponent,
    SigningComponent,
    CountyGeoComponent,
    TaxAuthorityComponent,
    AttachmentViewerComponent
  ],
  imports: [
    SharedModule,
    ProgressSpinnerModule
  ],
  exports: [
    SharedModule,
    IamTableComponent,
    IamPeriodComponent,
    SignProgressComponent,
    SigningComponent,
    CountyGeoComponent,
    TaxAuthorityComponent,
    AttachmentViewerComponent
  ]
})
export class EntitiesModule {
}
